export default __webpack_public_path__ + "static/media/thumb_up.1e633bad.svg";